module.exports = __webpack_public_path__ + "static/img/class_6.82069bb5.jpg";